<template>
  <div>
    <div class="lg">
      <van-dialog
        v-model="showCouponPop"
        confirmButtonText="确定"
        @confirm="confirmFn"
        @cancel="cancelFn"
        close-on-click-overlay
      >
        <div class="couponbox">
          <div class="content">
            <div
              class="mainitembox"
              v-for="item in cangetCouponList"
              :key="item.id"
            >
              <div class="canuseleftbox">
                <div class="padtop50" v-if="item.type == 'CASH'">
                  <span class="canlefticon">￥</span>
                  <span class="canleftnum">{{ item.benefitCash }}</span>
                </div>
                <div class="padtop50" v-if="item.type == 'DISCOUNT'">
                  <span class="canleftnumt"
                    >{{ item.benefitDiscount * 10 }}折券</span
                  >
                </div>
                <div class="canleftlable" v-if="item.conditionAmount > 0">
                  满{{ item.conditionAmount }}元使用
                </div>
                <div class="canleftlable" v-else>无门槛优惠券</div>
              </div>
              <div class="canrightbox">
                <div class="canrightinfo">
                  <div class="canrightvale">
                    <span v-if="item.type == 'CASH'">【现金券】</span>
                    <span v-if="item.type == 'DISCOUNT'">【折扣券】</span
                    >{{ item.name | formartName }}
                  </div>
                  <div class="canrightlable">
                    {{ item.memo }} 有效期
                    <span v-if="item.startDate">
                      {{ item.startDate | formartDate }}至
                      {{ item.endDate | formartDate }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-dialog>
    </div>
    <div class="zrlcontent">
      <el-dialog
        :visible.sync="showCouponPop"
        append-to-body
        class="zrlcontent"
      >
        <div class="couponbox zoomsmall">
          <div class="content">
            <div
              class="mainitembox"
              v-for="item in cangetCouponList"
              :key="item.id"
            >
              <div class="canuseleftbox">
                <div class="padtop50" v-if="item.type == 'CASH'">
                  <span class="canlefticon">￥</span>
                  <span class="canleftnum">{{ item.benefitCash }}</span>
                </div>
                <div class="padtop50" v-if="item.type == 'DISCOUNT'">
                  <span class="canleftnumt"
                    >{{ item.benefitDiscount * 10 }}折券</span
                  >
                </div>
                <div class="canleftlable" v-if="item.conditionAmount > 0">
                  满{{ item.conditionAmount }}元使用
                </div>
                <div class="canleftlable" v-else>无门槛优惠券</div>
              </div>
              <div class="canrightbox">
                <div class="canrightinfo">
                  <div class="canrightvale">
                    <span v-if="item.type == 'CASH'">【现金券】</span>
                    <span v-if="item.type == 'DISCOUNT'">【折扣券】</span
                    >{{ item.name | formartName }}
                  </div>
                  <div class="canrightlable">
                    {{ item.memo }} 有效期
                    <span v-if="item.startDate">
                      {{ item.startDate | formartDate }}至
                      {{ item.endDate | formartDate }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button class="color9866" @click="confirmFn">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  cangetCoupon_api,
  getCoupon_api,
  birthdayCoupon_api,
  updateBirthdayCoupon_api,
} from "../apis/layout";
export default {
  data() {
    return {
      cangetCouponList: [],
      showCouponPop: false,
      isBirthday: false,
    };
  },
  filters: {
    formartDate(val) {
      if (val) {
        // let newVal = val.substring(0, 10);
        // return newVal;
        return val;
      }
    },
    formartName(val) {
      // if(val.length>10){

      // }
      return val;
    },
  },
  methods: {
    async open() {
      let { code, data } = await cangetCoupon_api();
      if (code == 0) {
         this.cangetCouponList = data;
        // this.cangetCouponList = [
        //   {
        //     availablecount: 1,
        //     benefitDiscount: 0.9,
        //     benefitType: 1,
        //     categoryIds: "1677858571631529986",
        //     conditionAmount: 1500,
        //     couponcode: "",
        //     createTime: "2025-07-24 19:19:48",
        //     endDate: "2025-07-29 19:00:00",
        //     handlerId: "",
        //     id: "1948342343500374017",
        //     imageUrl: "",
        //     isDelete: 1,
        //     isactive: 1,
        //     limitperuser: 1,
        //     memo: "",
        //     name: "七月新品券1（仅限新品使用）",
        //     productIds:
        //       "1947543754893238273,1947537350761455617,1944582696398299137,1942793601099571201,1942793066350977025,1942786443104559106,1942784528576749570,1926829821052092418,1933908333932085249",
        //     receiveEnd: "2025-07-29 19:00:00",
        //     receiveStart: "2025-07-24 19:20:00",
        //     receiveType: 1,
        //     startDate: "2025-07-27 19:00:00",
        //     totalcount: 100,
        //     type: "DISCOUNT",
        //     updateTime: "2025-07-24 19:19:48",
        //     validDays: 0,
        //     validType: 1,
        //   },
        //   {
        //     availablecount: 1,
        //     benefitDiscount: 0.9,
        //     benefitType: 1,
        //     categoryIds: "1677858571631529986",
        //     conditionAmount: 1500,
        //     couponcode: "",
        //     createTime: "2025-07-27 12:28:15",
        //     endDate: "2025-07-29 19:00:00",
        //     handlerId: "",
        //     id: "1949325936791986177",
        //     imageUrl: "",
        //     isDelete: 1,
        //     isactive: 1,
        //     limitperuser: 1,
        //     memo: "",
        //     name: "七月新品券2（仅限新品使用）",
        //     productIds:
        //       "1947543754893238273,1947537350761455617,1944582696398299137,1942793601099571201,1942793066350977025,1942786443104559106,1942784528576749570,1926829821052092418,1933908333932085249",
        //     receiveEnd: "2025-07-29 19:00:00",
        //     receiveStart: "2025-07-27 12:35:00",
        //     receiveType: 1,
        //     startDate: "2025-07-27 19:00:00",
        //     totalcount: 100,
        //     type: "DISCOUNT",
        //     updateTime: "2025-07-27 12:28:15",
        //     validDays: 0,
        //     validType: 1,
        //   },
        //   {
        //     availablecount: 1,
        //     benefitDiscount: 0.9,
        //     benefitType: 1,
        //     categoryIds: "1677858571631529986",
        //     conditionAmount: 1500,
        //     couponcode: "",
        //     createTime: "2025-07-27 12:31:17",
        //     endDate: "2025-07-29 19:00:00",
        //     handlerId: "",
        //     id: "1949326702952914946",
        //     imageUrl: "",
        //     isDelete: 1,
        //     isactive: 1,
        //     limitperuser: 1,
        //     memo: "",
        //     name: "七月新品券3（仅限新品使用）",
        //     productIds:
        //       "1947543754893238273,1947537350761455617,1944582696398299137,1942793601099571201,1942793066350977025,1942786443104559106,1942784528576749570,1926829821052092418,1933908333932085249",
        //     receiveEnd: "2025-07-29 19:00:00",
        //     receiveStart: "2025-07-27 12:35:00",
        //     receiveType: 1,
        //     startDate: "2025-07-27 19:00:00",
        //     totalcount: 100,
        //     type: "DISCOUNT",
        //     updateTime: "2025-07-27 12:31:17",
        //     validDays: 0,
        //     validType: 1,
        //   },
        // ];

        if (this.cangetCouponList.length > 0) {
          this.showCouponPop = true;
          this.isBirthday = false;
          this.getCoupon();
        } else {
          this.getBirthdayCoupon();
        }
      } else if (code == 1) {
      }
    },
    cancelFn() {
      this.showCouponPop = false;
    },
    async confirmFn() {
      this.showCouponPop = false;
      // let idsList = [];
      // this.cangetCouponList.forEach((item) => {
      //   idsList.push(item.id);
      // });
      // let ids = idsList.join(",");
      // let { code, data } = await getCoupon_api({
      //   ids: ids,
      // });
      // if (code == 0) {
      //   // this.$dialog.alert({
      //   //   message: "请到“我的主页”查看优惠券",
      //   // });
      // }
      if (this.isBirthday) {
        let idsList = [];
        this.cangetCouponList.forEach((item) => {
          idsList.push(item.id);
        });
        let ids = idsList.join(",");
        let { code, data } = await updateBirthdayCoupon_api({
          ids: ids,
        });
        if (code == 0) {
          this.$dialog.alert({
            message: "请到“我的主页”查看生日券",
          });
        }
      } else {
        this.$dialog.alert({
          message: "请到“我的主页”查看优惠券",
        });
      }
    },
    async getCoupon() {
      let idsList = [];
      this.cangetCouponList.forEach((item) => {
        idsList.push(item.id);
      });
      let ids = idsList.join(",");
      let { code, data } = await getCoupon_api({
        ids: ids,
      });
      if (code == 0) {
      }
    },
    async getBirthdayCoupon() {
      let { code, data } = await birthdayCoupon_api();
      if (code == 0) {
        this.cangetCouponList = data;
        if (this.cangetCouponList.length > 0) {
          this.showCouponPop = true;
          this.isBirthday = true;
        }
        // this.cangetCouponList = [
        //   {
        //     benefitCash: null,
        //     benefitDiscount: 0.9,
        //     conditionAmount: 1500,
        //     couponcode: "",
        //     endDate: "2025-06-20 19:00:00",
        //     id: "1934868594251825153",
        //     imageUrl: "",
        //     isUse: 0,
        //     memo: "",
        //     name: "六月新品券1（仅限新品使用）",
        //     startDate: "2025-06-18 19:00:00",
        //     type: "DISCOUNT",
        //     useDate: "",
        //   },
        // ];
        // console.log(this.cangetCouponList);
        // this.showCouponPop = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.couponbox {
  background: #eeeee2;
  zoom: 0.8;
  padding: 10px;

  .content {
    width: 690px;
    margin: 0 auto;
  }

  .mainitembox {
    margin-top: 20px;
    border-radius: 15px;
    background: #fff;
    //   display: flex;
    //   justify-content: space-between;
    //   align-items: center;
  }

  .canuseleftbox {
    display: inline-block;
    vertical-align: top;
    width: 188px;
    height: 188px;
    background: #986665;
    border-radius: 15px 0px 0px 15px;
  }

  .padtop50 {
    padding-top: 30px;
    text-align: center;
  }

  .canlefticon {
    // margin-left: 34px;
    font-size: 30px;
    font-family: PingFang;
    font-weight: 500;
    color: #ffffff;
  }

  .canleftnum {
    font-size: 60px;
    font-family: PingFang;
    font-weight: bold;
    color: #ffffff;
  }

  .canleftnumt {
    font-size: 48px;
    font-family: PingFang;
    font-weight: bold;
    color: #ffffff;
  }

  .canleftlable {
    text-align: center;
    font-size: 24px;
    font-family: PingFang;
    font-weight: 500;
    color: #ffffff;
  }

  .canrightbox {
   // width: 502px;
     width: 402px;
    height: 188px;
    background: #ffffff;
    border-radius: 0px 15px 15px 0px;
    display: inline-block;
    vertical-align: top;
  }

  .wid717 {
    width: 717px;
  }

  .canrightinfo {
    margin-left: 30px;
    width: 470px;
    height: 188px;
    // background: #4d36ff;
    display: inline-block;
    vertical-align: top;
  }

  .canrightvale {
    font-size: 30px;
    font-family: PingFang;
    font-weight: 500;
    color: #333333;
    padding-top: 20px;
    margin-bottom: 20px;
  }

  .canrightlable {
    font-size: 20px;
    font-family: PingFang;
    font-weight: 500;
    color: #999999;
  }

  .canrightbtn {
    width: 112px;
    height: 44px;
    background: #986665;
    border-radius: 22px;
    display: inline-block;

    line-height: 44px;
    text-align: center;
    font-size: 20px;
    font-family: PingFang;
    font-weight: 500;
    color: #ffffff;
    position: relative;
    top: 72px;
  }

  .nocanrightbtn {
    text-align: center;
  }

  .canuserightbox {
    display: inline-block;
    vertical-align: top;
    width: 188px;
    height: 188px;
    background: #e4e4e4;
    border-radius: 15px 0px 0px 15px;
  }

  .canrighticon {
    margin-left: 34px;
    font-size: 30px;
    font-family: PingFang;
    font-weight: 500;
    color: #c9c9c9;
  }

  .canleftnumtwo {
    font-size: 60px;
    font-family: PingFang;
    font-weight: bold;
    color: #c9c9c9;
  }

  .canleftnumtwot {
    font-size: 48px;
    font-family: PingFang;
    font-weight: bold;
    color: #c9c9c9;
  }
}

.zrlcontent {
  display: none;
}

@media screen and (min-width: 1000px) {
  .lg {
    display: none;
  }

  .zrlcontent {
    display: block;
  }
}
.zoomsmall {
  zoom: 0.49;
}
.color9866 {
  background-color: #986665;
  color: #fff;
}
.el-button:hover {
  background-color: #986665 !important; /* 取消背景色 */
  color: #fff !important; /* 取消文本颜色 */
  border: #986665;
}
</style>